import React from 'react';
import { EntityTaskDetails } from 'components/common/tasks/entityTaskDetails';

export const CountryTaskDetails = () => {
  return <EntityTaskDetails entityName={'COUNTRY'} />;
};
